<template>
       <div>
          <v-dialog v-model="dialogState" width="400">
          <v-card>
              <v-toolbar color="error" class="elevation-0">
                  <v-avatar>
                      <v-img :src="require('../assets/logo.png')"></v-img>
                  </v-avatar>
                  <v-toolbar-title class="white--text font-weight-light">Winkelwagen legen</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn @click="hideDialog" icon class="white--text"> 
                      <v-icon>fal fa-times</v-icon>
                  </v-btn>
              </v-toolbar>
            <v-card-text>
             Na afsluiten word uw winkelwagen geleegd. Weet u zeker dat u wilt afsluiten?
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
             <v-flex xs12 text-xs-right>
                <v-btn @click="handleApprove" depressed color="error" class="text-none">Verwijderen</v-btn>
                  <v-btn @click="hideDialog" flat class="text-none"> Annuleren</v-btn>
             </v-flex>
            </v-card-actions>
          </v-card>
        </v-dialog>
     
       </div>
</template>



<script>
export default {
  model: {
    prop: 'dialog',
    event: 'dialog'
  },
  props: {
    dialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogState: this.dialog,
      reactions: [],
      loading: false
    }
  },
  watch: {
    dialog(val) {
      this.dialogState = val
    },
    dialogState(val) {
      this.$emit('dialog', val)
    }
  },
  methods: {
    hideDialog() {
      this.dialogState = false;
    },
    handleApprove() {
      this.$emit('confirmApprove')
      this.dialogState = false;
    }
  },

}
</script>
